// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"39bc4bc0","459":"8ce55b4d","832":"6439151b"}[chunkId] + ".chunk.js";
};